export const LOCKED_WEEK_MSG = "Editing is not permitted. This week is outside the 2-week editing window.";
